module.exports = __webpack_public_path__ + "static/media/3C.6ed5bf64.png";